/* 自营商家id（不包括自营摄影） */
export const SELF_BUSINESSIDS = [41215]

/* 商户类型 */
export const BUSINESS_TYPE = {
  czj: 20, //成长加
  yuer: 21, //育儿
  youle: 22, //游乐
  activity: 23, //互动活动
  photography: 24 //自营摄影
}

/* 用户信息 */
export type UserInfoType = {
  uid: number
  nickname: string
  photo: string
  truename?: string
  mobile?: string
}

/* 门店信息 */
export type StoreInfoType = {
  storeCode: string
  storeName: string
}

export enum LEVEL4CATEGORYID {
  SIGNED_YUESAO = 10112210,
  UNION_YUESAO = 10112211,
  NEW_SIGNED_YUESAO = 10112212
}

export enum OrderState {
  WaitPay = 10, //待支付
  WaitUse = 20, //待使用
  WaitEveluate = 30, //待评价
  Finished = 40, //已完成
  Canceled = 50, //已取消
  Expired = 70 //已过期
}
export const OrderStateText = {
  [OrderState.WaitPay]: '待支付',
  [OrderState.WaitUse]: '待使用',
  [OrderState.WaitEveluate]: '待评价',
  [OrderState.Finished]: '已完成',
  [OrderState.Canceled]: '已取消',
  [OrderState.Expired]: '已过期'
}
export enum OrderRefundState {
  WaitApply = 10, //未申请退款
  Applied = 20, //已申请退款
  Succeed = 30, //退款成功
  Failed = 40 //退款失败
}
export enum OrderWorkState {
  WaitApply = 0, //待上户
  Applied = 30, //已申请上户
  Refused = 35, //驳回上户
  Confirmed = 40 //已确认上户
}
export const OrderWorkStateText = {
  [OrderWorkState.WaitApply]: '未上户',
  [OrderWorkState.Applied]: '已申请上户',
  [OrderWorkState.Refused]: '驳回上户',
  [OrderWorkState.Confirmed]: '已确认上户'
}

export type OrderType = Partial<{
  orderId: string
  orderState: OrderState
  refundState: OrderRefundState
  userName: string
  userMobile: string
  payPrice: number
  workState: OrderWorkState
  signRefundInfo: {
    refundStartTime: number
  }
  workerInfo: {
    workerName: string
    workerCode: string
    starLevel: 1 | 2 | 3 | 4 | 5 //'三星', '四星', '五星', '金牌', '资深'
  }
  extInfo: string
  isPayPeriod: number
  payPeriodInfo: {
    prePayOrder: {
      preOrderState: OrderState
      preRefundState: OrderRefundState
    }
  }
}>

export const WorkerStarLevel = {
  1: '三星',
  2: '四星',
  3: '五星',
  4: '金牌',
  5: '资深'
}

export const LEVEL3CATEGORYID = {
  /* 孕产三级品类包括孕产服务、婴幼服务、家政服务、产后恢复、月嫂、孕婴健康、生活美容、技能培鉴、职业资质 */
  YunChan: [
    101110, 101111, 101116, 101121, 101122, 101123, 101124, 101317, 101318
  ],
  /* 自营摄影摄影三级品类 */
  ZiYingSheYing: [101215]
  /* 其余三级品类都算做成长加 */
}

export const ThirdScenicStatus: Record<number, string> = {
  0: '未定义',
  1: '营业中',
  2: '停业',
  4: '装修中',
  5: '尚未营业',
  6: '暂停营业'
}

export const TicketTypes: Record<number, string> = {
  0: '不限票',
  1: '儿童票',
  2: '老人票',
  3: '男人票',
  4: '女人票',
  5: '其他票',
  6: '学生票',
  7: '成人票',
  8: '优待票',
  9: '亲子家庭票'
}
